module.exports = __webpack_public_path__ + "static/media/Taavon_Eslami.ac15b6e0.svg";